/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable dot-notation */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/order */
/* eslint-disable react/prop-types */
import { Form, FormikProvider, useFormik } from 'formik';
import { useState } from 'react';
import { InputText, LoadingBtnBm, SelectBm, TypographyBm } from '../../components/@material-extend';
import { countries } from '../../data/countryData/countries';
import { state } from 'src/data/countryData/states';
import { AreaOfPolygon } from 'src/utils/AreaPolygon';
import * as Yup from 'yup';
import { ranchApi } from 'src/components/api';
import { stateLabel } from 'src/data/countryData/stateLabel';
import { Box, Divider, Stack } from '@mui/material';
import { SelectRancher } from './SelectRancher';
import { useNavigate } from 'react-router-dom';
import { useSnakBarTran } from 'src/hook';

const SurveyForm = ({ coord, uploadKey, stateData, partnerId }) => {
  let area;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(stateData.country || 'AR');
  const [selectedState, setSelectedState] = useState(stateData.state || 'Buenos Aires');
  const [rancherPK, setRancherPK] = useState(stateData.PK || '');
  const routerNavigate = useNavigate();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnakBarTran();
  let ranchDetail = {};


  const surveyFormSchema = Yup.object().shape({
    name: Yup.string().trim().min(2, 'Please enter a valid Name').required('Name is required'),
    address: Yup.string().trim().required('Address is a required field'),
    city: Yup.string().trim().required('City is a required field'),
    postal: Yup.string().trim().required('Enter postal code')
  });

  const formik = useFormik({
    initialValues: {
      name: stateData?.fieldName || '',
      ranchType: stateData.ranchType || 'Private',
      coordinates: '',
      years: '',
      address: stateData.address || '',
      postal: stateData.postalCode || '',
      city: stateData.city || '',
      partnerId: partnerId || '',
    },
    validationSchema: surveyFormSchema,
    onSubmit: async (values) => {
      if (!coord.length && (!uploadKey || uploadKey === '') && !stateData?.fieldName) {
        alert('Please either draw ranch boundary or upload map file of ranch');
        return;
      }
      try {
        const navState = {
          name: values.name,
          area,
          unit: 'acres'
        };
        setIsSubmitting(true);

        const ranchData = {
          fieldName: values.name,
          fieldType: values.ranchType.toUpperCase(),
          coordinates: JSON.stringify(coord),
          producerId: rancherPK,
          state: selectedState,
          country: selectedCountry,
          address: values.address,
          postalCode: values.postal,
          city: values.city,
          unit: 'acres',
          area,
          fieldCoordinateDoc: uploadKey,
          partnerId: values.partnerId || partnerId,
        };

        if (stateData?.fieldName) {
          const editData = {
            producerId: rancherPK,
            fieldId: stateData?.fieldId,
            status: stateData.status,
            unit: 'acres',
            city: values.city,
            postalCode: values.postal,
            address: values.address,
            state: selectedState,
            country: selectedCountry,
            fieldName: values.name,
            fieldType: values.ranchType.toUpperCase(),
            partnerId: values.partnerId || partnerId
          };
          await ranchApi.put('/editField', editData);
          navState['PK'] = stateData.PK;
          navState['SK'] = stateData.SK;
          showSuccessSnackbar({text:"Details updated successfully!"})
        } else {
          const { data } = await ranchApi.post('/addField', ranchData);
          navState['PK'] = data.PK;
          navState['SK'] = data.SK;
          ranchDetail = { ...data };
          showSuccessSnackbar({ text: 'Details added successfully!' });

        }

        if (!stateData.PK) {
          console.log("ProducerId =>", rancherPK);
          console.log("FieldId =>", ranchDetail?.fieldId);

          routerNavigate('../RanchQuestionnaire', {
            state: {
              otherDetails: ranchDetail,
              producerId: rancherPK,
              fieldId: ranchDetail?.fieldId,
              partnerId: ranchDetail?.userDetail?.oldPartnerId || ranchDetail?.partnerId,
            }
          });
        } else {
          routerNavigate('../ranchValidation');
        }
      } catch (error) {
        console.log(error);
        let err = error?.request?.response;
        err = err?.replaceAll('"', '') || 'Failed';
        showErrorSnackbar({text: err});
      } finally {
        setIsSubmitting(false);
      }
    }
  });

  const handleStateSelectChange = (event) => {
    setSelectedState(event.target.value);
  };

  const handleCountrySelectChange = (event) => {
    const { value } = event.target;
    setSelectedState(state[value][0]?.value || '');
    setSelectedCountry(value);
  };

  const { errors, touched, handleSubmit, getFieldProps } = formik;
  area = AreaOfPolygon(coord, true);

  const stateDesc = stateLabel[selectedCountry] || 'State';

  return (
    <div style={{ display: 'grid' }}>
      <FormikProvider value={formik}>
        <Form autoComplete="off" noValidate onSubmit={handleSubmit} style={{ marginTop: '-6%' }}>
          <div
            style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
          >
            <Box sx={{ display: 'flex' }}>
              <TypographyBm
                component="div"
                style={{
                  fontSize: '1rem',
                  fontFamily: 'Figtree',
                  margin: '0.5rem auto',
                  color: '#004752',
                  fontWeight: '600'
                }}
              >
                Ranch Details
              </TypographyBm>
            </Box>
            <Divider />
            <Stack
              spacing={2}
              padding="1rem"
              sx={{ overflowY: 'auto', maxHeight: '96vh', overflowX: 'hidden' }}
            >
              <InputText
                type="name"
                label="Ranch Name"
                {...getFieldProps('name')}
                error={Boolean(touched.name && errors.name)}
                helperText={touched.name && errors.name}
                sx={{ bgcolor: '#F1F1F1', borderRadius: 1 }}
                size="medium"
                errorBgColor="#fff"
              />
              <InputText
                type="name"
                label="Partner ID"
                {...getFieldProps('partnerId')}
                error={Boolean(touched.partnerId && errors.partnerId)}
                helperText={touched.partnerId && errors.partnerId}
                sx={{ bgcolor: '#F1F1F1', borderRadius: 1 }}
                size="medium"
                errorBgColor="#fff"
                // disabled={false}
                disabled={partnerId}
              />
              <SelectRancher
                partnerId={formik.values.partnerId || partnerId}
                defaultValue={stateData.producerId}
                value={rancherPK}
                setValue={setRancherPK}
              />
              <InputText
                label="Ranch Area"
                name="area"
                value={stateData.area || area}
                sx={{ bgcolor: '#F1F1F1', borderRadius: 1 }}
                size="medium"
                disabled
                errorBgColor="#fff"
                unit="acres"
              />
              <SelectBm
                size="medium"
                label="Ranch Ownership"
                fullWidth
                {...getFieldProps('ranchType')}
                sx={{ bgcolor: '#F1F1F1', borderRadius: 1 }}
                list={selectedCountry === 'MX' ? ['Private', 'Ejido'] : ['Private', 'Community']}
              />
              <TypographyBm sx={{ color: '#525A65' }} variant={'h6'}>
                Ranch Address
              </TypographyBm>
              <InputText
                type="address"
                label="Address"
                {...getFieldProps('address')}
                error={Boolean(touched.address && errors.address)}
                helperText={touched.address && errors.address}
                sx={{ bgcolor: '#F1F1F1', borderRadius: 1 }}
                size="medium"
                errorBgColor="#fff"
              />
              <InputText
                type="city"
                label="City"
                {...getFieldProps('city')}
                error={Boolean(touched.city && errors.city)}
                helperText={touched.city && errors.city}
                sx={{ bgcolor: '#F1F1F1', borderRadius: 1 }}
                size="medium"
                errorBgColor="#fff"
              />
              <SelectBm
                size="medium"
                label={`Select ${stateDesc}`}
                fullWidth
                value={selectedState || state[selectedCountry][0]?.value}
                onChange={handleStateSelectChange}
                sx={{ bgcolor: '#F1F1F1', borderRadius: 1 }}
                list={state[selectedCountry] || []}
              />
              <InputText
                type="postal"
                label="Postal Code"
                {...getFieldProps('postal')}
                error={Boolean(touched.postal && errors.postal)}
                helperText={touched.postal && errors.postal}
                sx={{ bgcolor: '#F1F1F1', borderRadius: 1 }}
                size="medium"
                errorBgColor="#fff"
              />
              <SelectBm
                size="medium"
                label="Select Country"
                fullWidth
                value={selectedCountry}
                onChange={handleCountrySelectChange}
                sx={{ bgcolor: '#F1F1F1', borderRadius: 1 }}
                list={countries}
              />
              <div style={{ margin: '1rem auto', width: '85%' }}>
                <LoadingBtnBm
                  loading={isSubmitting}
                  type="submit"
                  style={{ fontSize: '1rem', backgroundColor: '#005249', boxShadow: 'none' }}
                >
                  Save
                </LoadingBtnBm>
              </div>
            </Stack>
          </div>
        </Form>
      </FormikProvider>
    </div>
  );
};

export default SurveyForm;
